import { render, staticRenderFns } from "./start-study.vue?vue&type=template&id=3054a1a4&scoped=true&"
import script from "./start-study.vue?vue&type=script&lang=ts&"
export * from "./start-study.vue?vue&type=script&lang=ts&"
import style0 from "./start-study.vue?vue&type=style&index=0&id=3054a1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054a1a4",
  null
  
)

export default component.exports